import { render, staticRenderFns } from "./DefinirProporcaoPorSegmento.vue?vue&type=template&id=871cc866&scoped=true"
import script from "./DefinirProporcaoPorSegmento.vue?vue&type=script&setup=true&lang=js"
export * from "./DefinirProporcaoPorSegmento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DefinirProporcaoPorSegmento.vue?vue&type=style&index=0&id=871cc866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871cc866",
  null
  
)

export default component.exports